import { Typography } from '@components/typography';
import { classNames } from '@lib/classNames/classNames';
import { memo } from 'react';

import { TitleProps } from './types';

export const Title = memo((props: TitleProps) => {
  const { className, children, id } = props;

  return (
    <Typography
      variant="heading-xl"
      id={id}
      className={classNames({
        cls: 'mb-5 max-sm:mb-4',
        additional: [className],
      })}
    >
      {children}
    </Typography>
  );
});

Title.displayName = 'Title';
